// extracted by mini-css-extract-plugin
module.exports = {"base":"base--oYS9hI","loader":"loader--OQyZLf"};